$(document).ready(function () {
	$('.vg-nav a').click(function () {
		let link = $(this).attr('href');

		if (link.substr(0, 1) == '/') link = link.substr(1);

		if (link == '#') {
			// todo
			return false;
		} else if (link.substr(0, 1) == '#') {
			scrollTo($(link)[0]);
			return false;
		}
	});
});